import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CatNavbar from '../CatNavbar';
import { Box, Button, Container, Grid, GridItem, Heading, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import ProductCard from '../ProductCards/ProductCard';
import SearchNotFound from '../resources/SearchNotFound';
import NotFound from '../resources/NotFound';
import Loading from '../resources/Loading';
import FilterBar from './FilterBar';

export default function SearchResults() {
  const searchParams = new URLSearchParams(window.location.search);
  const query = searchParams.get('query');

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visibleproducts, setVisibleProducts] = useState(6);
  const hasMoreProductsToLoad = visibleproducts < results.length;

  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    state: '',
    district: '',
    radius: ''
  });
  const [userLocation, setUserLocation] = useState(null);

  // Get user's location for radius filtering
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setUserLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        });
      },
      (error) => {
        console.error("Error getting user location:", error);
      }
    );
  }, []);

  // Fetch search results with filters
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        let url = `https://api.agromanch.com/search?q=${query}`;
        
        if (filters.state) {
          url += `&state=${encodeURIComponent(filters.state)}`;
        }
        
        if (filters.district) {
          url += `&district=${encodeURIComponent(filters.district)}`;
        }
        
        if (filters.radius && userLocation) {
          url += `&radius=${filters.radius}&lat=${userLocation.lat}&lng=${userLocation.lng}`;
        }
        
        const response = await axios.get(url);
        setResults(response.data);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setError('An error occurred while fetching data.');
        setLoading(false);
      }
    };

    fetchData();
  }, [query, filters, userLocation]);

  // Handle filter changes
  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    // Reset visible products when filters change
    setVisibleProducts(6);
  };

  if (loading) {
    return <Loading />;
  }

  if (results.length === 0) {
    return (
      <Box>
        <Container maxW="container.xl">
          <FilterBar onFilterChange={handleFilterChange} initialFilters={filters} />
          <SearchNotFound />
        </Container>
      </Box>
    );
  }

  if (error) {
    return <NotFound />;
  }

  return (
    <Box>
  
      <Container maxW="container.xl">
        <Heading as="h2" size="lg" mb={4}>
          Search Results for "{query}"
        </Heading>
        
        <FilterBar onFilterChange={handleFilterChange} initialFilters={filters} />
        
        <Grid templateColumns={{ base: "1fr", md: "repeat(auto-fit, minmax(300px, 1fr))" }} gap={6}>
          {results.slice(0, visibleproducts).map((product) => (
            <GridItem key={product._id}>
              <Link to={`/preview_ad/${product._id}`}>
                <ProductCard product={product} />
              </Link>
            </GridItem>
          ))}
        </Grid>
        
        {hasMoreProductsToLoad && (
          <Box textAlign="center" mt={8}>
            <Button
              className="mb-2"
              bgGradient="linear(to-r, teal.400, cyan.600)"
              color="white"
              _hover={{
                bgGradient: "linear(to-r, teal.600, cyan.800)",
              }}
              _active={{
                bgGradient: "linear(to-r, teal.800, cyan.900)",
              }}
              onClick={() => {
                setVisibleProducts((prev) => prev + 10);
              }}
            >
              Load More
            </Button>
          </Box>
        )}
      </Container>
    </Box>
  );
}

